export default __webpack_public_path__ + "static/media/logo.f2daa131.png";